import React from "react"
import AccountPage from "./AccountPage"
import RBAC from "aldoo-ra/RBAC/rbac"
import SiteSignIn from "../../Signin"

const Page = ({ section, activationMode }) => {
  return <AccountPage section={section} activationMode={activationMode} />
}

// Require only authentication (no specific permission)
const ProtectedAccountPage = RBAC({
  permission: null, // No specific permission required
  grantAt: SiteSignIn
})(Page)

export default ProtectedAccountPage